import React, { useState, useContext } from 'react';
import { VegaButtonLink, VegaBox } from "@heartlandone/vega-react";
import SendEmailNotificationPopup from 'Components/SendEmailNotificationPopup/SendEmailNotificationPopup';
import { HubContext } from "Redux/Context/context";
import { reloadActivitiesAction, manuallySentEmailIncrementAction } from 'Redux/Actions/actions';

function SendEmailNotificationAction({ activity }) {
  const { id, emailNotificationSentCount = 0 } = activity;
  const { manuallySentEmailState, reloadActivitiesDispatch, manuallySentEmailDispatch } = useContext(HubContext);
  const existingCount = manuallySentEmailState?.[id] || emailNotificationSentCount;
  const maxCount = 3;
  const [isEmailPopupOpen, setIsEmailPopupOpen] = useState(false);
  const [actionDisbaled, setActionDisbaled] = useState(existingCount >= maxCount);

  const onSended = (status) => {
    if(status === 'success') {
      manuallySentEmailDispatch(manuallySentEmailIncrementAction(id));
    }
    const updatedCount = (status === 'success') ? existingCount + 1 : existingCount;
    setActionDisbaled(updatedCount >= maxCount);
    if(status === 'success'){
      reloadActivitiesDispatch(
        reloadActivitiesAction({reloadBy: 'email-sended'})
      );
    }
  };

  const onClose = () => {
    setIsEmailPopupOpen(false);
  };

  return (
    <VegaBox flexShrink={0} flexGrow={0}>
      <VegaButtonLink
        label={`Send Email Notification (${existingCount}/${maxCount})`}
        icon="far fa-envelope"
        onVegaClick={() => setIsEmailPopupOpen(true)}
        disabled={actionDisbaled}
      />
      {
        <SendEmailNotificationPopup
          activityId={id}
          isOpen={isEmailPopupOpen}
          onClose={onClose}
          onSended={onSended}
          sentCount={existingCount}
          maxCount={maxCount}
        />
      }
    </VegaBox>
  );
}

export default SendEmailNotificationAction;
